import { PeopleCards } from './peopleCards';

export default PeopleCards;
